module.exports = "/_next/static/images/43c8a5b7294df6836a8f254069ff1e4c-bill-reopen-package.png.webp";